<div *ngIf="bookingSet" >
  <tr *ngFor="let booking of bookingSet?.bookings" class="mb-2">
    <td>

    <sb-comp-image-name-wrapper [medium]="booking?.medium" [still]="true"
                                [hoverPreview]="true">
      <span firstLine [innerHTML]="booking?.medium?.name | truncate:30"></span>
      <span secondLine>
                                                        {{'lang.globals.commercial'|translate}}: <span
        [innerHTML]="booking?.name |truncate:30"></span>
                                                    </span>
    </sb-comp-image-name-wrapper>
    </td>
    <td>
  <sb-comp-image-name-wrapper [image]="booking?.advertiser?.logo?.url">
    <span [innerHTML]="booking?.advertiser?.name | truncate : 35" firstLine></span>
  </sb-comp-image-name-wrapper>
  </td>
  </tr>
</div>
